// Modern Table Styles based on UI Foundations Kit Simple Table
export const tableStyles = {
  container: {
    borderRadius: 2,
    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
    border: 'none',
    overflow: 'hidden',
  },
  headerRow: {
    backgroundColor: '#FAFAFA',
  },
  headerCell: {
    fontWeight: 600,
    color: '#374151',
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    borderBottom: '1px solid #E5E7EB',
    py: 1.5,
    px: 1,
  },
  sortableHeaderCell: {
    fontWeight: 600,
    color: '#374151',
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    borderBottom: '1px solid #E5E7EB',
    py: 1.5,
    px: 1,
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: '#F3F4F6',
    },
  },
  bodyRow: {
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: '#F9FAFB',
    },
  },
  bodyRowAlternate: {
    backgroundColor: '#FFFFFF',
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: '#F9FAFB',
    },
  },
  bodyCell: {
    borderBottom: '1px solid #F3F4F6',
    py: 1.5,
    px: 1,
    fontSize: '0.8rem',
    color: '#111827',
  },
  groupRow: {
    backgroundColor: '#F3F4F6',
    borderBottom: '1px solid #E5E7EB',
  },
  emptyRow: {
    py: 6,
    textAlign: 'center',
  },
};

// Nested table styles for page breakdowns
export const nestedTableStyles = {
  container: {
    mt: 0,
    mb: 0,
    border: 'none',
    backgroundColor: 'transparent',
  },
  headerCell: {
    fontWeight: 600,
    color: '#6B7280',
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    borderBottom: '1px solid #E5E7EB',
    py: 1,
    px: 1,
    backgroundColor: '#FAFAFA',
  },
  bodyCell: {
    borderBottom: '1px solid #F3F4F6',
    py: 1,
    px: 1,
    fontSize: '0.8rem',
    color: '#374151',
  },
  snakeRow: {
    backgroundColor: '#FEF3C7',
  },
};
